import React, { useState } from 'react';
import { Paper, TextField, Button, Typography } from '@mui/material';
import { getAuth, sendSignInLinkToEmail } from 'firebase/auth';

const EmailAuthGate = ({ secretId, decryptKey }) => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const sendLink = async () => {
    const auth = getAuth();
    const actionCodeSettings = {
      url: `${window.location.origin}/verify-email?secretId=${secretId}`,
      handleCodeInApp: true,
    };

    localStorage.setItem('decryptionKey', decryptKey);

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('authEmail', email);
      setSent(true);
    } catch (error) {
      console.error(error);
      alert('Failed to send email link.');
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Email Verification Required
      </Typography>
      {sent ? (
        <Typography>Verification email sent! Please check your inbox.</Typography>
      ) : (
        <>
        <Typography>The creator of the secret enforces E-Mail Authentication. You need to enter a valid E-Mail Address.</Typography>
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button variant="contained" color="primary" onClick={sendLink}>
            Send Verification Link
          </Button>
        </>
      )}
    </Paper>
  );
};

export default EmailAuthGate;